module.exports = __webpack_public_path__ + "media/images/posts/2563286-b99be7d5ec5c72e392c7ea981be07f0b.jpg";